export default {"src":"/_next/static/media/icon-stake.7b3b4424.svg","height":30,"width":34,"blurWidth":0,"blurHeight":0};